import { createRefPath } from "global/firestoreData/appData/appRefPaths";
import _ from 'lodash';
import { useContext, useEffect, useMemo, useState } from "react";
import { DatabaseContext } from "../DatabaseContext";
import { PapsContext } from "../PapsContext";
import { useCacheDataManager } from "./useCacheDataManager";
import { _showAppLogs, LogContext } from "../LogContext";
import { _cacheGroupTypes } from "./useTimestamp";

export const useHomeInfo = () => {

  // logContext
  const logContext = useContext(LogContext)
  const { log_handlers } = logContext ?? {}

  const cdm = useCacheDataManager()

  const papsContext = useContext(PapsContext);
  const { paps_state } = papsContext
  const { pathViews } = paps_state ?? {}
  const { clients: clientKey } = pathViews ?? {}

  const databaseContext = useContext(DatabaseContext);
  const { database_fns } = databaseContext ?? {};

  const [clients, setClients] = useState()

  // Guard to prevent multiple fetches
  const [initialized, setInitialized] = useState(false);

  // ------------------- Helper -------------------
  const fetchAndCache = async (key, fetchFn, setterFn) => {

    const cache_groupType = _cacheGroupTypes.homeInfo;
    const cache_key = key;

    try {
      // 1️⃣ Try cache first
      const cached = await cdm.getSubItem(cache_groupType, cache_key);

      if (!_.isEmpty(cached)) {
        setterFn(cached);
        _showAppLogs.addLog && log_handlers.addLog(`♻️ℹ️ Loaded ${cache_groupType} from cache`)
        // setClients(cached)
        return;
      }

      // 2️⃣ Fetch from Firebase and update cached bundle
      const callback = async (data) => {
        setterFn((prev) => {
          if (!_.isEqual(prev, data)) {
            _showAppLogs.appInfo && log_handlers.addLog(`🌐💾 Updated ${cache_groupType} from Firebase`)
            cdm.mergeToGroup(cache_groupType, cache_key, data);
            return data;
          }
          return prev;
        });
      };

      getDataWrapper(database_fns, fetchFn(pathViews, callback));
    } catch (err) {
      console.error(`❌💾 Error fetching ${key}:`, err);
    }
  };

  useEffect(() => {
    if (!database_fns || initialized) return;

    setInitialized(true);

    (async () => {
      try {
        const fetches = [
          fetchAndCache("clients", getConfig_clients, setClients),
        ];

        await Promise.all(fetches);
      } catch (err) {
        console.error(`❌ Failed to fetch event data`, err);
      }
    })();
  }, [clientKey]);

  // ------------------- Memoized stable return -------------------
  const homeInfo = useMemo(
    () => ({ clients }),
    [clients]
  );

  return homeInfo;

};

const getDataWrapper = (database_fns, config) => {
  if (!config?.refPath || !config?.callback) {
    console.error("getDataWrapper: Missing refPath or callback", config);
    return;
  }
  database_fns.get_data(config);
};

const getConfig_clients = (pathViews, callback) => ({
  refPath: createRefPath(['clients']),
  callback,
  opts: { listen: false },
});
